import React from 'react'

const Footer = () => {
    return (
        <div className="container mt-5">
            <div className="card rounded-0 border-0 shadow footercard">
                <div className="row mx-0 mx-sm-4 mx-md-5">
                    <div className="col-12 text-center">
                        <span className="text-dark">Copyright &copy; 2024</span>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer